export default __webpack_public_path__ + "static/Account-26af74fbba1ba4dd84b6c202042588db.jpg";